import { UPDATE_INTERACTION, LOADING } from 'core/actions/constants'
import { peachApi } from 'core/api'

const updateInteraction = ({ key, personId, id, personIdIsNull, body }) => {
  return async dispatch => {
    if (key) {
      dispatch({
        type: LOADING,
        key,
        status: 'loading'
      })
    }

    try {
      const response = await peachApi.put({
        url: `/people/${personId}/interactions/${id}`,
        body
      })
      dispatch({
        type: UPDATE_INTERACTION,
        payload: response.data,
        personId: personIdIsNull ? null : personId,
        id
      })
      if (key) {
        dispatch({ type: LOADING, key, status: 'success' })
      }
      return response
    } catch {
      if (key) {
        dispatch({ type: LOADING, key, status: 'error' })
      }
    }
  }
}

export default updateInteraction
